module.exports = __webpack_public_path__ + "static/media/GainOnBlack.33ed39c2.svg";